<template>
  <div>
    <LoadingProgress :show-loading="showLoading" />
  </div>
</template>

<script>
import LoadingProgress from '@/components/LoadingProgress'
export default {
  name: 'LoadingWithProps',
  components: { LoadingProgress },
  props: {
    showLoading: {
      type: Boolean
    }
  }
}
</script>
